






























import Vue from 'vue'
import { mapState } from 'vuex'
import { snackbarState, portalState, mutations } from '@/state'
import Global, { isMobile } from './helpers/mixins.js'
import { EventBus } from './helpers/event.bus'
import { DARKMODE_LOCAL_STORAGE_KEY } from '@/constants'
import { apiGetAccount } from '@/api'
import { testEnvironment } from './helpers/mixins.js'

import { Loader, TextLogo, TopLeftButtons, TopRightButtons } from './components'
import Zendesk from './views/Zendesk.vue'
import Snackbar from '@/components/Global/Snackbar.vue'
import EditAccountDrawer from '@/components/Users/EditAccountDrawer.vue'
import MainNavigation from './components/Navigation/Main.vue'
import Banner from '@/components/Navigation/MaintenanceBanner.vue'

export default Vue.extend({
  name: 'App',
  components: {
    Loader,
    TopRightButtons,
    TopLeftButtons,
    TextLogo,
    MainNavigation,
    Snackbar,
    EditAccountDrawer,
    Zendesk,
    Banner
  },
  mixins: { Global } as any,
  computed: {
    ...mapState(['user', 'socket']),
    ...mapState('Auth', ['loading', 'authenticated']),
    ...mapState('Debug', { 'debuggerActive': 'active' }),
    ...mapState(['locale']),
    language (): string { return this.locale?.key || 'en' },
    permissions () {
      return this.user.permissions
    },
    snackbarState () {
      return snackbarState.snackbar
    },
    nightMode () {
      return portalState.nightMode
    }
  },
  data () {
    return {
      $moment: null,
      $auth: null,
      editUserDrawerOpened: false,
      accountInfo: null,
      isMobile: isMobile()
    }
  },
  methods: {
    updateSnackbar (e: boolean) {
      setTimeout(() => {
        snackbarState.snackbar = {
          active: false,
          severity: 'info',
          message: 'snackbar message'
        }
      }, 500)
    },
    editAccountHandler () {
      if (this.editUserDrawerOpened) {
        this.editUserDrawerOpened = false
        return
      }
      apiGetAccount().then((res: any) => {
        this.accountInfo = res.data.data
        this.editUserDrawerOpened = true
      })
    }
  },
  created (): void {
    EventBus.$on('setLocale', (lang: Record<string, any>) => {
      const language = lang?.key || 'en'
      this.$moment.locale(language)
      this.$vuetify.lang.current = language
    })
  },
  mounted (): void {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    this.$store.commit('setTimezone', { zone })

    const testUrl = testEnvironment()
    if (testUrl) {
      document.title = `${testUrl.replace('.', '')} - Portal Tracefy`
      const favicon: HTMLLinkElement | null = document.querySelector('[rel=icon]')
      if (favicon) favicon.href = '/img/accicons/favicon-32x32.png'
    }
    const browserDarkmode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    const isThemeSet = localStorage.getItem(DARKMODE_LOCAL_STORAGE_KEY) !== null
    if (isThemeSet) {
      this.$vuetify.theme.dark = localStorage.getItem(DARKMODE_LOCAL_STORAGE_KEY) === 'true'
    } else if (browserDarkmode) {
      this.$vuetify.theme.dark = true
    }
  },
  watch: {
    $route (to: Record<string, any>, from: Record<string, any>) {
      if (from.name === 'map' && to.name === from.name) {
        return
      }

      if (this.socket && !this.debuggerActive) {
        console.log('live updates stopped')
        this.socket.emit('stop tracking all')
      }
    },
    authenticated (authenticated: boolean) {
      if (this.user && !authenticated) {
        this.$auth.logout()
      }
      if (this.isMobile && this.$route.name !== 'install-devices-mobile' && this.hasPermission('create:entity')) {
        this.$router.push({ path: 'install-devices-mobile' })
      }
    },
    nightMode (val: boolean) {
      this.$vuetify.theme.dark = val
    },
    loading (loading: boolean) {
      if (this.user === 'error') {
        window.location.href = 'https://maintenance.tracefy.com'
        return
      }
      if (!loading && !this.authenticated) {
        this.$auth.loginWithRedirect()
      }
    },
    permissions (val) {
      const { permission } = this.$route.meta
      const permitted = val.some((r: string) => r === permission)
      if (!permitted) this.$router.push('/')
    }
  }
} || {})
